/* eslint-disable camelcase */
import { SECOND_VERSION_APP_SPORTS } from '@/components/pages/TraderMode/utils/sportsById'
import { cloneDeep } from '@/utils/utils'

const parseMessage = message => {
  try {
    return JSON.parse(message)
  } catch (err) {
    return null
  }
}

export default {
  data () {
    return {
      websocket: null,
      firstScore: true,
      currentTranslation: null,
      pingInterval: 0,
      pingsCounter: 0,
      logOnlyOption: false,
      isTimersSynchronized: false,
      isReconnecting: false,
      isMatchEnded: false,
      scoutOnlineTimeout: null,
      cachedActionTypes: {},
      eventsStepByStepQueue: []
    }
  },
  created () {
    if (this.$route.query.step_by_step) {
      document.addEventListener('keyup', this.stepByStepListener)

      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('keyup', this.stepByStepListener)
      })
    }
  },
  methods: {
    stepByStepListener ({ code }) {
      if (code !== 'Space') return

      // eslint-disable-next-line no-console
      console.log(this.eventsStepByStepQueue[0].EventCode, this.eventsStepByStepQueue[0])

      this.processEvent(this.eventsStepByStepQueue[0])

      this.eventsStepByStepQueue.shift()
    },
    processPenaltyShootouts (event) {
      const { getMatchPeriods } = this
      const {
        extra: { is_shootout },
        GamePeriod
      } = event
      const { [GamePeriod]: currentPeriod } = getMatchPeriods
      const { overriddenType } = currentPeriod

      if (
        SECOND_VERSION_APP_SPORTS.includes(this.sportName) &&
        (!is_shootout || (overriddenType && overriddenType === 'shootout'))
      ) { return }

      this.setPenaltyShootouts(event)
    },
    // this fn will process 'HEARTBEAT' events
    processHeartBeat (event) {
      const { online } = this.scoutInfo
      const { ping } = event.extra

      clearTimeout(this.scoutOnlineTimeout)

      this.setPing(ping)

      if (!online) {
        this.setScout({
          property: 'online',
          value: true
        })
      }

      this.scoutOnlineTimeout = setTimeout(() => {
        this.setScout({
          property: 'online',
          value: false
        })
      }, 8000)
    },

    processSet (event) {
      const { ScoreHome, ScoreAway } = event

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: ScoreHome,
          away: ScoreAway
        }
      })
    },

    // this fn will process 'MATCH_FORMAT' events
    processMatchFormat (event) {
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format,
        has_tackles
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set,
        has_tackles
      })

      if (!is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    },
    // this fn will add default events in event log
    defaultProcessionFunction (event) {
      // console.log('what is this? its default event', event)
    },
    processPossession (event) {
      const { TeamNumber } = event

      this.setActiveSide(TeamNumber)
    },
    processApp (event) {
      const { EventCode, extra } = event

      switch (EventCode) {
        case 'APP_STOP':
          this.setScout({
            property: 'isAppStopped',
            value: true
          })

          break
        case 'APP_START':
          const { scoutAppVersion, appVersion, battery } = extra

          if (scoutAppVersion || appVersion) {
            this.setScout({
              property: 'appVersion',
              value: scoutAppVersion || appVersion
            })
          }

          this.setBattery(battery)

          this.setScout({
            property: 'isAppStopped',
            value: false
          })
      }
    },
    processScore (event) {
      this.setScore(event)
    },
    processAdjustScore (event) {
      this.setScore(event)
    },
    processLocation (event) {
      // console.log('location', event)
    },
    processCancel (event) {
      const { ScoreHome, ScoreAway } = event
      // TODO подумать, как правильно определять тип действия на отмену. Сейчас пусть будет только для score
      this.setScore(event)
      this.setCanceled(event)
      this.refreshDelayedEvents(event)

      // TODO посмотреть что это и как убрать
      if (typeof ScoreHome === 'number' && typeof ScoreAway === 'number') {
        this.setIngameProperty({
          property: 'sets',
          value: {
            home: ScoreHome,
            away: ScoreAway
          }
        })
      }
    },
    processBetstop ({ EventCode }) {
      if (EventCode === 'BETSTOP') return this.setBetstop(true)

      return this.setBetstop(false)
    },
    processTimeout ({ EventCode, TeamNumber }) {
      const value = EventCode === 'TIMEOUT'

      this.setTeamTimeout({ TeamNumber, value })
    },
    processFinish (event) {
      const { getSettings, sport } = this
      const { isTimerDisabled } = getSettings
      const { customVictoryTitle } = sport.methods

      if (!isTimerDisabled) {
        this.setTimerStarted(false)
      }

      this.setWinner(event)

      if (customVictoryTitle) {
        const getcustomVictoryTitle = customVictoryTitle.bind(this)

        this.setCustomVictoryTitle(getcustomVictoryTitle(event))
      }
    },
    processMainTimer (event) {
      this.setTimer(event)
    },
    processFoul (event) {
      this.setFouls(event)
    },
    getProcessFn (event) {
      const { EventCode } = event

      const eventActionType = this.getActionType(EventCode)
      let fn = this.getPriorityFunction(EventCode, eventActionType)

      if (fn) return fn

      fn = this.getProcessFnByEventCode(EventCode)

      if (fn) return fn

      switch (eventActionType) {
        case 'foul':
          return this.processFoul
        case 'score':
          return this.processScore
        case 'set':
          return this.processSet
        case 'activeSide':
          return this.processPossession
        case 'app':
          return this.processApp
        case 'cancel':
          return this.processCancel
        case 'betStop':
          return this.processBetstop
        case 'timeout':
          return this.processTimeout
        case 'mainTimer':
          return this.processMainTimer
      }

      return this.defaultProcessionFunction
    },
    getProcessFnByEventCode (eventCode) {
      switch (eventCode) {
        case 'LOCATION':
          return this.processLocation
        case 'HEARTBEAT':
          return this.processHeartBeat
        case 'MATCH_FORMAT':
          return this.processMatchFormat
        case 'FINISH_GAME':
          return this.processFinish
        case 'START_SHOOTOUT':
          return this.processPenaltyShootouts
        case 'ADJUST_SCORE':
          return this.processAdjustScore
      }
    },
    getActionType (eventCode) {
      const { getDefaultActionTypes, cachedActionTypes } = this
      const cachedActionType = cachedActionTypes[eventCode]
      let actionType

      if (cachedActionType) return cachedActionType

      actionType = Object.keys(getDefaultActionTypes).find(type => {
        return getDefaultActionTypes[type].find(item => item === eventCode)
      })

      if (!actionType) actionType = 'default'

      cachedActionTypes[eventCode] = actionType

      return actionType
    },
    // it looks for most priority process fn
    getPriorityFunction (eventCode, eventActionType) {
      const { byEventType, byActionType } = this.sport.methods

      if (byEventType.hasOwnProperty(eventCode)) return byEventType[eventCode].bind(this)

      if (eventActionType && byActionType.hasOwnProperty(eventActionType)) { return byActionType[eventActionType].bind(this) }

      return null
    },
    getEventInfo (eventCode) {
      const { currentSportEvents, generalEvents } = this

      let eventInfo = currentSportEvents[eventCode]

      if (!eventInfo) eventInfo = generalEvents[eventCode]

      return eventInfo
    },
    // this fn calls on each event in message with msg_type = "events"
    processEvent (newEvent) {
      const { eventPlaytimeFunction } = this.sport.methods
      const {
        scoreInPoints,
        hasMapsPeriod,
        disableSetScoreInProcessEvent,
        isPlaytimeByPeriod,
        isPlaytimeReverse
      } = this.getSettings
      const { getFormats } = this

      const event = cloneDeep(newEvent)

      const { Playtime, GamePeriod } = event

      if (isPlaytimeByPeriod && GamePeriod) {
        const {
          matchFormat: {
            duration: mainDuration
          }
        } = getFormats

        const time = Playtime - (mainDuration * (GamePeriod - 1) * 60 * 1000)

        event.Playtime = isPlaytimeReverse
          ? (mainDuration * 60 * 1000) - time
          : time
      }

      if (hasMapsPeriod && event.extra) {
        event.GamePeriod = event.extra.mapsPeriod
        event.extra.period = event.extra.mapsPeriod
      }

      const { EventCode, RelatedEventNumber } = event
      const needToSetScore = scoreInPoints
        ? event.extra
          ? (event.extra.hasOwnProperty('points-1_byPeriod') ||
              !!event.extra.hasOwnProperty('points-1')) &&
            (!!event.extra.hasOwnProperty('points-2_byPeriod') ||
              !!event.extra.hasOwnProperty('points-2'))
          : false
        : event.ScoreHome && event.ScoreAway

      if (!EventCode) return

      if (this.firstScore && this.getActionType(EventCode) === 'score') {
        this.firstScore = false

        this.$bus.$emit('trader-mode-first-score')
      }

      if (EventCode === 'GAME_START') {
        this.$bus.$emit('trader-mode-game-start')
      }

      if (EventCode === 'FINISH_GAME') {
        this.isMatchEnded = true
        this.$bus.$emit('trader-mode-game-finish')
      }

      if (
        event.extra &&
        event.extra.hasOwnProperty('for_customers') &&
        !event.extra.for_customers &&
        !['HEARTBEAT', 'INNER_SYNC_EVENT', 'APP_START', 'LOCATION'].includes(EventCode)
      ) {
        return
      }

      if (event.extra && event.extra.teamSide) {
        this.setHomeTeamSide(event.extra.teamSide)
      }

      const eventInfo = this.getEventInfo(EventCode)

      if (!eventInfo) return

      const processFn = this.getProcessFn(event)

      if (typeof processFn !== 'function') {
        const relatedEvent = this.getRelatedEvent(RelatedEventNumber)

        if (!this.logOnlyOption) {
          this.setStatistic(event, relatedEvent)
        }

        return
      }

      event.eventInfo = eventInfo

      this.setPeriod(event)

      if (event.EventCode !== 'HEARTBEAT' || !this.isTimersSynchronized) {
        this.setPlaytime(event)
        this.setDelayedEvents(event)

        if (!this.isTimersSynchronized && event.EventCode !== 'HEARTBEAT') {
          this.isTimersSynchronized = true
        }
      }

      if (
        !(disableSetScoreInProcessEvent) &&
        event.GamePeriod &&
        needToSetScore &&
        !['LOCATION', 'FINISH_GAME', 'APP_STOP'].includes(EventCode)
      ) {
        this.setScore(event)
      }

      const processedInfo = processFn(event)

      const relatedEvent = this.getRelatedEvent(RelatedEventNumber)

      if (event.EventCode === 'CANCEL' && !relatedEvent) {
        return
      }

      if (event.EventCode === 'ADJUST_EVENT_TIME' && !relatedEvent) {
        return
      }

      const eventTitle = this.getEventTitle(event, relatedEvent)
      const eventCounters = this.getEventCounters(event, relatedEvent)
      const customClass = this.getEventCustomClass(event, relatedEvent)
      const customSound = this.getEventCustomSound(event, relatedEvent)

      if (this.hasTackles) {
        this.setTackles(event)
      }

      if (!this.logOnlyOption) {
        this.setStatistic(event, relatedEvent)
      }

      if (
        event.extra &&
        (event.extra.team1 || event.extra.team1 === 0) &&
        (event.extra.team2 || event.extra.team2 === 0)
      ) {
        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: event.extra.team1,
            away: event.extra.team2
          }
        })
      }

      this.addToEventLog({
        event,
        relatedEvent,
        eventTitle,
        eventCounters,
        processedInfo,
        customClass,
        eventPlaytimeFunction,
        customSound,
        logOnlyOption: this.logOnlyOption,
        isMatchEnded: this.isMatchEnded
      })

      if (this.emitFinishEvent && EventCode === 'FINISH_GAME') {
        this.$emit('finishEvent')
      }
    },
    // functions to process different types of messages
    message_events ({ events }) {
      events.forEach(event => {
        if (this.$route.query.step_by_step) {
          this.eventsStepByStepQueue.push(event)

          return
        }

        this.processEvent(event)
      })
    },
    message_subscribe_history_sent () {
      this.setHistorySent(true)
    },
    message_subscribe_response ({ status, scout_id }) {
      if (status === 'failed' && !this.isAdmin && !this.isBooked('video') && !this.isBooked('vt')) {
        this.setError('error.translation.notAvailable')
      }

      if (!scout_id) {
        this.checkScoutsInTranslation()

        this.setHistorySent(true)

        return
      }

      this.scoutId = scout_id
      this.setScout({ property: 'id', value: scout_id })
    },
    checkScoutsInTranslation () {},
    message_ping (message) {
      this.pingsCounter = 0

      this.sendMessage({
        msg_type: 'pong',
        timestamp: message.timestamp
      })
    },
    message_pong () {
      this.pingsCounter = 0
    },
    message_login_response ({ status }) {
      if (status === 'failed') {
        console.error('websocket_login_failed')
        this.$bus.$emit('logout')

        return
      }

      const { scoutId, translationId, user } = this

      const userIdIfHasAbilities =
        !this.user.hasAbility('list-translation') && user.hasAbility('scout-translation')
          ? { scout_id: user.id }
          : {}

      this.sendMessage({
        msg_type: 'subscribe_request',
        translation_id: translationId,
        ...(scoutId ? { scout_id: scoutId } : userIdIfHasAbilities)
      })
    },
    getMessageType (type) {
      if (!type) return false

      return this[`message_${type}`]
    },

    // general websocket functions
    initWebsocket (translation, { logOnly }) {
      this.currentTranslation = translation

      const { isBooked, user, authKey, isAdmin } = this
      const { trader } = translation
      const defaultHighwayUrl = this.defaultWebsocketHWUrl
      const { email } = user.info

      if ((!isBooked('data') && !isAdmin) || !defaultHighwayUrl) {
        this.setHistorySent(true)

        return
      }

      if (logOnly) {
        this.logOnlyOption = true
      }

      this.websocket = new WebSocket(trader.highway_url || defaultHighwayUrl)

      this.websocket.onopen = () => {
        this.setWebsocketListeners()

        this.sendMessage({
          msg_type: 'login_request',
          username: email,
          auth_key: authKey
        })

        this.pingInterval = setInterval(() => {
          this.sendMessage({
            msg_type: 'ping'
          })
        }, 5000)

        this.isReconnecting = false
      }

      this.websocket.onerror = ev => {
        setTimeout(() => {
          this.tryToReconnect()
        }, 3000)
      }

      // TODO добавить обработчик на onerror
    },
    closeWebsocket () {
      clearInterval(this.pingInterval)

      this.pingInterval = 0
      this.pingsCounter = 0

      if (
        this.websocket &&
        this.websocket.readyState &&
        [WebSocket.CLOSED, WebSocket.CLOSING].includes(this.websocket.readyState)
      ) {
        return
      }

      this.websocket.close()
    },
    tryToReconnect () {
      const { logOnlyOption: logOnly } = this

      this.isReconnecting = true

      this.closeWebsocket()

      this.initWebsocket(this.currentTranslation, { logOnly })
    },
    setWebsocketListeners () {
      this.websocket.onmessage = message => {
        const data = parseMessage(message.data)

        if (!data) console.error('cannot parse message data')

        const { msg_type } = data

        const fn = this.getMessageType(msg_type, data)

        if (fn === false) return

        if (typeof fn !== 'function') {
          console.error('undefined message type', msg_type)

          return
        }

        fn(data)
      }
    },
    sendMessage (data) {
      if (!data) {
        return
      }

      if (data.msg_type === 'ping') {
        this.pingsCounter += 1
      }

      if (this.pingsCounter > 20) {
        console.error('Lose coonection', data)

        this.tryToReconnect()

        return
      }

      if ([WebSocket.CLOSING, WebSocket.CLOSED].includes(this.websocket.readyState)) {
        console.error('Connection Closed', data)

        this.tryToReconnect()

        return
      }

      if (this.websocket.readyState === WebSocket.CONNECTING) {
        console.error('Still connecting to the server, try again later', data)

        return
      }

      this.websocket.send(JSON.stringify(data))
    }
  }
}
